import React, { Fragment, useEffect, useState } from "react";
import { Redirect, useHistory, useLocation, useParams } from "react-router-dom";
import Experiencia from "../../components/Experiencia";
import Educacion from "../../components/Educacion";
import Habilidades from "../../components/Habilidades";
import LogrosCert from "../../components/LogrosCertificaciones";
import Idiomas from "../../components/Idiomas";
import Contrato from "../../components/Contrato";

import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import toast from "react-hot-toast";

import user from "../../static/images/user_default.png";
import iconshare from "../../static/images/icon-share.svg";
import icondownload from "../../static/images/icon-download.svg";
import editbutton from "../../static/images/edit-button.svg";

import download from "downloadjs";

import portada from "../../static/images/banner_default.png";

import Modal from "react-bootstrap/Modal";
import AgregarRecomendacion from "../../components/Recomendaciones/AddRecommendation";
import Recommendations from "../../components/Recomendaciones/index";
import { Insignias } from "../Applicant/Perfil";
import AreasInteres from "../../components/AreasInteres";

function Candidato({ reload }) {
  const [applicantData, setApplicantData] = useState("");
  const [flag, setflag] = useState(false);
  const [loading, setLoading] = useState(true);
  const [updateProfileModal, setupdateProfile] = useState(false);

  ///Metodo para mostrar y ocultar modal de creacion de perfil
  const [show, setShow] = useState(false);
  const location = useLocation();
  const params = useParams();

  const [recommendations, setRecommendations] = useState([]);

  useEffect(() => {
    const getApplicant = async () => {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("tok");
      let applicantId = 0;
      if (location.state !== undefined) {
        applicantId = location.state.userid;
      } else if (params.id !== undefined) {
        applicantId = params.id;
      }
      axios.get("access/applicant-id/" + applicantId).then((result) => {
        if (result.status === 200) {
          if (!result.data.aboutme) {
            toast.error("Perfil no valido");
            return <Redirect to="/company/Vacante/EstadoVacantes"></Redirect>;
          } else {
            setApplicantData(result.data);
            getRecommendations(result.data.userId.userId);

            setupdateProfile(true);
            setLoading(false);
            showProfilePic(result.data.image, result.data.coverImage);
          }
          // UploadPictures(result.data.applicantProfileId);
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      });
    };
    const getRecommendations = async (userId) => {
      await axios.get(`recommendation/${userId}`).then((result) => {
        if (result.status === 200) {
          setRecommendations(result.data);
        }
      });
    };
    getApplicant();
  }, [flag, location]);

  function postProfile(values) {
    let profile = {
      names: values.names,
      lastnames: values.lastnames,
      birthdate: values.birthdate,
      genderId: values.genderId,
      aboutme: values.aboutme,
      bannerImage: null,
      fotoProfile: null,
      applicantId: 0,
      profession: values.profession,
    };

    axios
      .post("access/create-applicantprofile", profile)
      .then((result) => {
        if (result.status === 200) {
          // setflagUploadImage(true);
          setflag(true);
          setShow(false);
          // setupdateProfile(true);

          // UploadPictures(applicantData.applicantProfileId);
          toast.success("Se ha creado su perfil exitosamente", {
            duration: 6000,
          });
        }
      })
      .catch(function (error) {
        if (error.response.status === 403) {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
        }
        if (error.response.status === 400) {
          toast.error(error.response.data.message);
        }
      });
  }

  function updateProfile(values) {
    let profile = {
      names: values.names,
      lastnames: values.lastnames,
      birthdate: values.birthdate,
      genderId: values.genderId,
      aboutme: values.aboutme,
      bannerImage: null,
      fotoProfile: null,
      applicantId: applicantData.applicantProfileId,
      profession: values.profession,
    };

    axios
      .post("access/update-applicantprofile/", profile)
      .then((result) => {
        if (result.status === 200) {
          // setflagUploadImage(false);
          // setupdatePictureProfile(true);
          setflag(flag ? false : true);
          // UploadPictures(applicantData.applicantProfileId);
          toast.success("Se ha actualizado su perfil exitosamente", {
            duration: 6000,
          });
        }
      })
      .catch(function (error) {
        if (error.response.status === 400) {
          toast.error(error.response.data.message);
        } else {
          toast.error(error.response.data.message);
        }
      });
  }

  function showProfilePic(profile, banner) {
    const pp = document.getElementById("profilePic");
    if (profile !== null) {
      pp.src = profile;
    }

    const bp = document.getElementById("bannerPic");
    if (banner !== null) {
      bp.src = banner;
    } else {
      bp.src = portada;
    }
  }

  function DescargarCV(applicant_id, name, lastname) {
    axios
      .get("access/pdf-cv/" + applicant_id, {
        responseType: "blob", // had to add this one here
      })
      .then((result) => {
        if (result.status === 200) {
          const content = result.headers["content-type"];
          download(result.data, "CV_" + name + " " + lastname, content);
          toast.success("Descargando", {
            duration: 4000,
          });
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      })
      .catch((e) => {
        if (!e.status) {
          toast.error(
            "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
            { duration: 5000 }
          );
        }
      });
  }

  function ActualizarPortada() {
    let banner = document.getElementById("bannerImageUpdate");

    let formData = new FormData();
    formData.append("bannerImage", banner.files[0]);

    axios
      .post(
        "access/create-photoprofile/" + applicantData.applicantProfileId,
        formData
      )
      .then((result) => {
        if (result.status === 200) {
          setflag(flag ? false : true);
          toast.success("Se ha actualizado la portada exitosamente", {
            duration: 6000,
          });
        }
      })
      .catch(function (error) {
        if (error.response.status === 403) {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
        }
        if (error.response.status === 400) {
          toast.error(error.response.data.message);
        }
      });
  }

  function ActualizarPerfil() {
    let banner = document.getElementById("profileImageUpdate");

    let formData = new FormData();

    formData.append("profileImage", banner.files[0]);
    axios
      .post(
        "access/create-photoprofile/" + applicantData.applicantProfileId,
        formData
      )
      .then((result) => {
        if (result.status === 200) {
          reload();
          setflag(flag ? false : true);
          toast.success("Se ha actualizado su foto de perfil exitosamente", {
            duration: 6000,
          });
        }
      })
      .catch(function (error) {
        if (error.response.status === 403) {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
        }
        if (error.response.status === 400) {
          toast.error(error.response.data.message);
        }
      });
  }

  const Validaciones = Yup.object().shape({
    names: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
    lastnames: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
    aboutme: Yup.string()
      .required("No puede estar vacio")
      .max(900, "No puede tener mas de 900 caracteres"),
    profession: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
  });

  const ppCss = {
    maxWidth: "233px",
    maxHeight: "233px",
    width: "100%",
    height: "100%",
    borderRadius: "10px",
  };

  const ppBanner = {
    width: "100%",
    height: "100%",
  };
  return (
    <Fragment>
      {loading ? (
        <label className="login-label">CARGANDO</label>
      ) : (
        <div className="profile">
          <div className="profile__header">
            <div className="profile__header-container">
              <div className="profile__cover-photo ">
                <img
                  id="bannerPic"
                  src={
                    applicantData.coverImage !== null
                      ? applicantData.coverImage
                      : portada
                  }
                  className="no-cover-image"
                  alt="No cover"
                  style={ppBanner}
                />
              </div>
              <div className="profile__header-content">
                <div className="profile__row">
                  <div className="profile__info">
                    <div className="profile__photo">
                      <img
                        id="profilePic"
                        src={user}
                        alt=""
                        style={ppCss}
                      ></img>
                    </div>
                    <div className="profile__details">
                      <h1 className="profile__name">
                        {applicantData.names} {applicantData.lastnames}
                      </h1>
                      <div className="profile__position">
                        {applicantData.profession}
                      </div>
                      <div className="profile__list">
                        <ul>
                          <li>
                            <span>Fecha de Nacimiento: </span>
                            {applicantData.birthdate}
                          </li>
                          <li>
                            <span>Género: </span>
                            {applicantData.genderId
                              ? applicantData.genderId.description
                              : ""}
                          </li>
                          <li>
                            <span>Ubicación Actual: </span>
                            {applicantData.department
                              ? applicantData.department.name
                              : ""}
                          </li>
                        </ul>
                      </div>
                      <div className="icon-tools">
                        <div className="icon-tools-wrapper">
                          <a href="#" className="icon-tools__share">
                            <img
                              src={iconshare}
                              alt="Share"
                              onClick={() => {
                                let host = window.location.hostname;
                                //in the case host having a port, include it in the url
                                if (window.location.port) {
                                  host = host + ":" + window.location.port;
                                }
                                let finalUrl = `http://${host}/compartir/candidato/${applicantData.applicantProfileId}`;
                                let Title = `Visita el perfil de ${applicantData.names} ${applicantData.lastnames} en Krezco, la red social de desarrollo profesional`;
                                navigator.share({
                                  title: Title,
                                  url: finalUrl,
                                });
                              }}
                            ></img>
                          </a>
                          <a href="#" className="icon-tools__download">
                            <img
                              src={icondownload}
                              alt="Download"
                              onClick={() => {
                                DescargarCV(
                                  applicantData.applicantProfileId,
                                  applicantData.names,
                                  applicantData.lastnames
                                );
                              }}
                            ></img>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="profile__row">
                  <Insignias id={applicantData.userId.userId} />

                  <div className="profile__about">
                    <div className="row-title">Acerca de mí</div>
                    <p>{applicantData.aboutme}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section className="body-profile">
            <div className="container">
              <div className="row">
                <div className="col-7  ">
                  <Experiencia
                    data={applicantData.applicantProfileId}
                    edit={false}
                  ></Experiencia>
                  <Educacion
                    data={applicantData.applicantProfileId}
                    edit={false}
                  ></Educacion>
                  <Habilidades
                    data={applicantData.applicantProfileId}
                    edit={false}
                  ></Habilidades>
                  <Idiomas
                    data={applicantData.applicantProfileId}
                    edit={false}
                  ></Idiomas>
                  <LogrosCert
                    data={applicantData.applicantProfileId}
                    edit={false}
                  ></LogrosCert>
                  <div className="box left-col">
                    <div className="head">
                      <div className="title">Recomendaciones</div>
                      <AgregarRecomendacion
                        toUser={
                          applicantData.userId.userId &&
                          applicantData.userId.userId
                        }
                        setRecommendations={setflag}
                      ></AgregarRecomendacion>
                    </div>
                    {recommendations &&
                      recommendations.map((item) => {
                        return (
                          <Recommendations
                            recommendation={item}
                          ></Recommendations>
                        );
                      })}

                    <div className="testimonial__footer">
                      <span className="view-more">
                        Mostrar más recomendaciones
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-5 sidebar">
                  <Contrato
                    data={applicantData.applicantProfileId}
                    edit={false}
                  />

                  {applicantData && (
                    <AreasInteres
                      applicantProfileId={applicantData.applicantProfileId}
                    />
                  )}
                </div>
              </div>
            </div>
          </section>
          <div
            id="crear-perfil-modal"
            className="kr-modal modal fade show"
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="modal-title"></div>

                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div className="modal-body">
                  <div className="form form--white ">
                    <Formik
                      initialValues={{
                        names: "",
                        lastnames: "",
                        birthdate: "1989-01-02",
                        genderId: "",
                        aboutme: "",
                        profession: "",
                      }}
                      onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(true);
                        postProfile(values);
                        setSubmitting(false);
                      }}
                      validationSchema={Validaciones}
                    >
                      {({ errors, touched, isSubmitting }) => (
                        <Form>
                          <div className="div__wrapper">
                            <div className="form__title text-center">
                              Crear Perfil
                            </div>
                            <div className="form__description text-center">
                              Formulario de prueba de creacion de Perfil.
                            </div>
                            <div className="form__row">
                              <div className="col-sm-12 col-md-8">
                                <label htmlFor="profileImage">Profile</label>
                                <input
                                  id="profileImage"
                                  type="file"
                                  required
                                ></input>
                              </div>
                              <div className="col-sm-12 col-md-8">
                                <label htmlFor="bannerImage">Banner</label>
                                <input
                                  id="bannerImage"
                                  type="file"
                                  required
                                ></input>
                              </div>
                            </div>
                            <div className="form__row">
                              <div className="col-sm-12 ">
                                <label htmlFor="names">Nombres</label>
                                <Field
                                  type="text"
                                  name="names"
                                  id="names"
                                  required
                                ></Field>
                                {errors.names && touched.names && (
                                  <span className="form__validation form__validation--error">
                                    {errors.names}
                                  </span>
                                )}
                              </div>
                              <div className="col-sm-12 ">
                                <label htmlFor="lastnames">Apellidos</label>
                                <Field
                                  type="text"
                                  name="lastnames"
                                  id="lastnames"
                                  required
                                ></Field>
                                {errors.lastnames && touched.lastnames && (
                                  <span className="form__validation form__validation--error">
                                    {errors.lastnames}
                                  </span>
                                )}
                              </div>
                              <div className="col-sm-12 ">
                                <label htmlFor="profession">Profesion</label>
                                <Field
                                  type="text"
                                  name="profession"
                                  id="profession"
                                  required
                                ></Field>
                                {errors.profession && touched.profession && (
                                  <span className="form__validation form__validation--error">
                                    {errors.profession}
                                  </span>
                                )}
                              </div>
                              <div className="col-sm-12 ">
                                <label htmlFor="birthdate">
                                  Fecha Nacimiento
                                </label>
                                <Field
                                  type="date"
                                  name="birthdate"
                                  id="birthdate"
                                  required
                                ></Field>
                                {errors.birthdate && touched.birthdate && (
                                  <span className="form__validation form__validation--error">
                                    {errors.birthdate}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="form__row">
                              <label htmlFor="gender">Género</label>
                              <Field
                                as="select"
                                name="genderId"
                                id="genderId"
                                required
                              >
                                <option value="" disabled hidden>
                                  Elija un género
                                </option>
                                <option value="2">Masculino</option>
                                <option value="1">Femenino</option>
                              </Field>
                              {errors.genderId && touched.genderId && (
                                <span className="form__validation form__validation--error">
                                  {errors.genderId}
                                </span>
                              )}
                            </div>
                            <div className="form__row">
                              <label htmlFor="aboutme">Acerca de mi</label>
                              <Field
                                as="textarea"
                                type="text"
                                name="aboutme"
                                id="aboutme"
                                required
                              ></Field>
                              {errors.aboutme && touched.aboutme && (
                                <span className="form__validation form__validation--error">
                                  {errors.aboutme}
                                </span>
                              )}
                            </div>
                            <div className="form__row">
                              <button
                                disabled={isSubmitting}
                                type="submit"
                                className="btn btn--gradient btn__icon btn__icon--door"
                              >
                                Guardar
                              </button>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {updateProfileModal ? (
            <div
              id="actualizar-perfil-modal"
              className="kr-modal modal fade"
              tabIndex="-1"
              role="dialog"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <div className="modal-title"></div>

                    <button
                      type="button"
                      className="close"
                      data-bs-dismiss="modal"
                      aria-label="close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div className="modal-body">
                    <div className="form form--white ">
                      <Formik
                        initialValues={{
                          names: applicantData.names,
                          lastnames: applicantData.lastnames,
                          birthdate: applicantData.birthdate,
                          genderId: applicantData.genderId
                            ? applicantData.genderId.genderId
                            : "",
                          aboutme: applicantData.aboutme,
                          profession: applicantData.profession,
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                          setSubmitting(true);
                          updateProfile(values);
                          setSubmitting(false);
                        }}
                        validationSchema={Validaciones}
                      >
                        {({ errors, touched, isSubmitting }) => (
                          <Form>
                            <div className="div__wrapper">
                              <div className="form__title text-center">
                                Actualizar Perfil
                              </div>
                              <div className="form__description text-center">
                                Formulario de actualizacion de datos.
                              </div>
                              <div className="form__row">
                                <div className="col-sm-12 ">
                                  <label htmlFor="names">Nombres</label>
                                  <Field
                                    type="text"
                                    name="names"
                                    id="names"
                                    required
                                  ></Field>
                                  {errors.names && touched.names && (
                                    <span className="form__validation form__validation--error">
                                      {errors.names}
                                    </span>
                                  )}
                                </div>
                                <div className="col-sm-12 ">
                                  <label htmlFor="lastnames">Apellidos</label>
                                  <Field
                                    type="text"
                                    name="lastnames"
                                    id="lastnames"
                                    required
                                  ></Field>
                                  {errors.lastnames && touched.lastnames && (
                                    <span className="form__validation form__validation--error">
                                      {errors.lastnames}
                                    </span>
                                  )}
                                </div>
                                <div className="col-sm-12 ">
                                  <label htmlFor="profession">Profesion</label>
                                  <Field
                                    type="text"
                                    name="profession"
                                    id="profession"
                                    required
                                  ></Field>
                                  {errors.profession && touched.profession && (
                                    <span className="form__validation form__validation--error">
                                      {errors.profession}
                                    </span>
                                  )}
                                </div>
                                <div className="col-sm-12 ">
                                  <label htmlFor="birthdate">
                                    Fecha Nacimiento
                                  </label>
                                  <Field
                                    type="date"
                                    name="birthdate"
                                    id="birthdate"
                                    required
                                  ></Field>
                                  {errors.birthdate && touched.birthdate && (
                                    <span className="form__validation form__validation--error">
                                      {errors.birthdate}
                                    </span>
                                  )}
                                </div>
                              </div>
                              <div className="form__row">
                                <label htmlFor="gender">Género</label>
                                <Field
                                  as="select"
                                  name="genderId"
                                  id="genderId"
                                  required
                                >
                                  <option value="" disabled hidden>
                                    Elija un género
                                  </option>
                                  <option value="2">Masculino</option>
                                  <option value="1">Femenino</option>
                                </Field>
                                {errors.genders && touched.genders && (
                                  <span className="form__validation form__validation--error">
                                    {errors.genders}
                                  </span>
                                )}
                              </div>
                              <div className="form__row">
                                <label htmlFor="aboutme">Acerca de mi</label>
                                <Field
                                  as="textarea"
                                  type="text"
                                  name="aboutme"
                                  id="aboutme"
                                  required
                                ></Field>
                                {errors.aboutme && touched.aboutme && (
                                  <span className="form__validation form__validation--error">
                                    {errors.aboutme}
                                  </span>
                                )}
                              </div>
                              <div className="form__row">
                                <button
                                  disabled={isSubmitting}
                                  type="submit"
                                  className="btn btn--gradient btn__icon btn__icon--door"
                                >
                                  Actualizar
                                </button>
                              </div>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div></div>
          )}

          <div
            id="actualizar-portada-modal"
            className="kr-modal modal fade"
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="modal-title"></div>

                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div className="modal-body">
                  <div className="form form--white ">
                    <div className="div__wrapper">
                      <div className="form__description text-center">
                        Seleccione una imagen
                      </div>
                      <div className="form__row">
                        <div className="col-sm-12 col-md-8">
                          <label htmlFor="bannerImageUpdate">Banner</label>
                          <input
                            id="bannerImageUpdate"
                            type="file"
                            required
                          ></input>
                        </div>
                      </div>
                      <div className="form__row">
                        <button
                          onClick={ActualizarPortada}
                          className="btn btn--gradient btn__icon btn__icon--door"
                        >
                          Actualizar Portada
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            id="actualizar-foto-perfil-modal"
            className="kr-modal modal fade"
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="modal-title"></div>

                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div className="modal-body">
                  <div className="form form--white ">
                    <div className="div__wrapper">
                      <div className="form__description text-center">
                        Seleccione una imagen
                      </div>
                      <div className="form__row">
                        <div className="col-sm-12 col-md-8">
                          <input
                            id="profileImageUpdate"
                            type="file"
                            required
                          ></input>
                        </div>
                      </div>
                      <div className="form__row">
                        <button
                          onClick={ActualizarPerfil}
                          className="btn btn--gradient btn__icon btn__icon--door"
                        >
                          Subir Perfil
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Modal
        show={show}
        backdrop="static"
        keyboard={false}
        dialogClassName="kr-modal"
      >
        <Modal.Body>
          <div className="form form--white ">
            <Formik
              initialValues={{
                names: "",
                lastnames: "",
                birthdate: "1989-01-02",
                genderId: "",
                aboutme: "",
                profession: "",
              }}
              onSubmit={(values, { setSubmitting }) => {
                setSubmitting(true);
                postProfile(values);
                setSubmitting(false);
              }}
              validationSchema={Validaciones}
            >
              {({ errors, touched, isSubmitting }) => (
                <Form>
                  <div className="div__wrapper">
                    <div className="form__title text-center">Crear Perfil</div>
                    <div className="form__row">
                      <div className="col-sm-12 ">
                        <label htmlFor="names">Nombres</label>
                        <Field
                          type="text"
                          name="names"
                          id="names"
                          required
                        ></Field>
                        {errors.names && touched.names && (
                          <span className="form__validation form__validation--error">
                            {errors.names}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-12 ">
                        <label htmlFor="lastnames">Apellidos</label>
                        <Field
                          type="text"
                          name="lastnames"
                          id="lastnames"
                          required
                        ></Field>
                        {errors.lastnames && touched.lastnames && (
                          <span className="form__validation form__validation--error">
                            {errors.lastnames}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-12 ">
                        <label htmlFor="profession">Profesion</label>
                        <Field
                          type="text"
                          name="profession"
                          id="profession"
                          required
                        ></Field>
                        {errors.profession && touched.profession && (
                          <span className="form__validation form__validation--error">
                            {errors.profession}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-12 ">
                        <label htmlFor="birthdate">Fecha Nacimiento</label>
                        <Field
                          type="date"
                          name="birthdate"
                          id="birthdate"
                          required
                        ></Field>
                        {errors.birthdate && touched.birthdate && (
                          <span className="form__validation form__validation--error">
                            {errors.birthdate}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="form__row">
                      <label htmlFor="gender">Género</label>
                      <Field as="select" name="genderId" id="genderId" required>
                        <option value="" disabled hidden>
                          Elija un género
                        </option>
                        <option value="2">Masculino</option>
                        <option value="1">Femenino</option>
                      </Field>
                      {errors.genderId && touched.genderId && (
                        <span className="form__validation form__validation--error">
                          {errors.genderId}
                        </span>
                      )}
                    </div>
                    <div className="form__row">
                      <label htmlFor="aboutme">Acerca de mi</label>
                      <Field
                        as="textarea"
                        type="text"
                        name="aboutme"
                        id="aboutme"
                        required
                      ></Field>
                      {errors.aboutme && touched.aboutme && (
                        <span className="form__validation form__validation--error">
                          {errors.aboutme}
                        </span>
                      )}
                    </div>
                    <div className="form__row">
                      <button
                        disabled={isSubmitting}
                        type="submit"
                        className="btn btn--gradient btn__icon btn__icon--door"
                      >
                        Guardar
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default Candidato;
